import React, { createContext, useCallback, useMemo, useState } from "react";
import { RequestedListing } from "../types";

interface RequestedListingContextData {
  listing: RequestedListing[];
  setListing: (listing: RequestedListing[]) => void;
}

export const ListingContext = createContext<RequestedListingContextData>({
  listing: [],
  setListing: () => { },
});

export const ListingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

  const [listing, setListingState] = useState<RequestedListing[]>([]);
  const setListing = useCallback((listing: RequestedListing[] | []) => {
    setListingState(listing);
  }, []);

  const value = useMemo(() => ({ listing, setListing }), [listing, setListing]);

  return (
    <ListingContext.Provider value={value}>
      {children}
    </ListingContext.Provider>
  );
};
